import { Component } from 'react'
import { API } from 'aws-amplify'
import config from './Config'

const apiPath = config.apiGatewaySolarReactivation.PATH

class SolarReactivationClient extends Component {
	getStatus() {
		return API.post(apiPath, 'solar-reactivation/config/get-status', {})
	}

	setMaster(active) {
		return API.post(apiPath, 'solar-reactivation/config/set-master', {
			body: { active }
		})
	}

	setCounty(county, active) {
		return API.post(apiPath, 'solar-reactivation/config/set-county', {
			body: { county, active }
		})
	}

	setAll(active) {
		return API.post(apiPath, 'solar-reactivation/config/set-all', {
			body: { active }
		})
	}

	setSettings(settings) {
		return API.post(apiPath, 'solar-reactivation/config/set-settings', {
			body: settings
		})
	}

	recomputeCounters() {
		return API.post(apiPath, 'solar-reactivation/config/recompute-counters', {})
	}
}

export default SolarReactivationClient
